export const CLASSIFICATION_TYPES = {
    MEAN: 'mean',
    JENKS: 'jenks',
}
